/**
 * Like Array.join but works with ReactNodes instead of strings.
 */
export function joinNodes(nodes, separator) {
  // eslint-disable-next-line unicorn/no-array-reduce
  return nodes.reduce((previousValue, currentValue) => previousValue === null ? currentValue : <>
					{previousValue}
					{separator}
					{currentValue}
				</>, null);
}